<template>
  <header class="sidearm-mm-main-header flex flex-align-center fixed px-2">
    <img
      :src="$root.school_logo(72, 72)"
      :alt="$root.data.school.name ? $root.data.school.name : 'School Logo'"
      class="mr-2"
    />
    <!-- A|B Test -->
    <!-- <nav
      class="sidearm-mm-main-header__quick-nav flex flex-align-center flex-auto"
    >
      <ul class="reset flex flex-align-center">
        <li
          v-for="section in $root.navigation"
          :key="section.anchor"
          :data-section="section.anchor"
          :class="{
            'is-active': $root.active_anchor === section.anchor
          }"
          class="flex flex-align-center"
        >
          <button
            @click="full_page_navigate_to(section.anchor)"
            type="button"
            class="relative"
          >
            <span class="absolute px-2 py-1">{{ section.title }}</span>
          </button>
        </li>
      </ul>
    </nav> -->

    <div
      class="sidearm-mm-main-header__tag flex flex-align-center ml-auto mr-2"
    >
      <div
        v-if="
          this.$root.final_four_location.name &&
            this.$root.final_four_location.abbrev
        "
        class="flex flex-align-center"
      >
        <span class="mr-2"
          ><span class="hide-on-small-down">The </span> Road To</span
        >
        <abbr :title="this.$root.final_four_location.name">{{
          this.$root.final_four_location.abbrev
        }}</abbr>
      </div>
    </div>

    <ad
      name="tournament-cs-main-header-1"
      :sport-id="$root.sport_id"
      class="hide-on-medium-down sidearm-mm-main-header__sponsor mr-2"
    />

    <div class="sidearm-mm-main-header__logo-container ml-auto px-2"></div>

    <button
      @click="toggle_navigation()"
      :class="{
        'is-toggled': navigation_open
      }"
      type="button"
      class="sidearm-mm-main-header__menu-toggle relative flex flex-align-center reset"
    >
      <span>Menu</span>
    </button>

    <main-navigation v-model="navigation_open" />
  </header>
</template>

<script>
import MainNavigation from "@/components/MainNavigation.vue";

export default {
  components: {
    MainNavigation
  },

  data: () => ({
    navigation_open: false
  }),

  methods: {
    toggle_navigation(value) {
      if (value !== undefined) {
        this.navigation_open = !!value;
      } else {
        this.navigation_open = !this.navigation_open;
      }
    },

    full_page_navigate_to(anchor) {
      this.$emit("navigate", anchor);
    }
  }
};
</script>

<style lang="scss" scoped>
.sidearm-mm-main-header {
  background-color: $color-black;
  color: $color-white;
  font-size: 1.125rem;
  font-weight: 700;
  height: 120px;
  left: 50%;
  top: 60px;
  transform: translateX(-50%);
  transition: 0.35s;
  width: 75%;
  z-index: 100;

  &__quick-nav {
    @include flex-item(1 1 0px);

    li {
      transition: 0.35s;

      &:not(:last-child) {
        &::after {
          @include flex-item(0 0 0px);

          border-top: 1px dashed $stroke-on-light;
          content: "";
          opacity: 0;
          display: block;
          height: 1px;
          transition: 0.35s;
        }
      }
    }

    button {
      @include base-reset();

      border-radius: 50%;
      display: block;
      height: 1.5rem;
      width: 1.5rem;

      &::before {
        border: 0.75rem solid $stroke-on-dark;
        border-radius: 50%;
        content: "";
        display: block;
        height: 100%;
        left: 50%;
        position: absolute;
        top: 50%;
        transform: translate(-50%, -50%) scale(0.25);
        width: 100%;
      }

      &:hover {
        span {
          @include unhide();

          background-color: $color-white;
          color: $color-black;
          left: 50%;
          position: absolute;
          top: calc(60px + 0.75rem);
          transform: translateX(-50%);
          width: auto;
          height: auto;
        }
      }
    }

    span {
      @include hide();

      display: block;
      font-size: 1.125rem;
      font-weight: 700;
      white-space: nowrap;
    }
  }

  &__menu-toggle {
    height: $spacer * 2.83;
    padding-left: $spacer * 6;
    transition: transform 0.35s;
    transform-origin: top left;

    &::before,
    &::after {
      background-color: $color-white;
      content: "";
      display: block;
      height: 2px;
      left: 0;
      position: absolute;
      transition: 0.35s;
    }

    &::before {
      bottom: 50%;
      transform: translateY(-100%);
      width: $spacer * 4;
    }

    &::after {
      left: $spacer * 2;
      top: 50%;
      transform: translateY(100%);
      width: $spacer * 2;
    }

    &:hover {
      &::before {
        transform: translate(#{$spacer/2}, -100%);
      }
      &::after {
        transform: translate(#{$spacer/2}, 100%);
      }
    }
  }

  &__tag {
    abbr {
      -webkit-text-stroke: 1px $color-white;
      color: rgba($color-white, 0);
      font-family: $font-abolition;
      font-size: 64px;
      font-weight: 400;
      text-decoration: none;
    }
  }

  &__logo-container,
  &__gameday-link {
    @include hide();
  }

  @media (max-width: #{$breakpoint-x-large}) {
    background-color: $color-black !important;
    color: $color-white !important;
    top: 0px !important;
    transform: translateX(-50%) !important;
    height: 84px;
    padding: $spacer 0 $spacer $spacer * 2;
    width: 100% !important;

    &__quick-nav {
      display: none;
    }

    > img {
      height: 48px;
    }

    &__menu-toggle {
      border-left: 1px dashed $color-white;
      padding: 0 $spacer * 6 0 $spacer * 2;

      &::before,
      &::after {
        background-color: $color-white !important;
        left: auto;
        right: 0;
      }

      &:hover {
        &::before {
          transform: translate(#{$spacer/-2}, -100%);
        }
        &::after {
          transform: translate(#{$spacer/-2}, 100%);
        }
      }
    }

    &__tag {
      > span:first-child {
        margin-right: $spacer;
      }

      abbr {
        -webkit-text-stroke-color: $color-white !important;
        color: rgba($color-white, 0) !important;
        font-size: 30px;
      }
    }
  }
}
</style>

<style lang="scss">
body {
  &[class*="fp-viewing"]:not(.fp-viewing-home),
  &.main-nav-is-toggled {
    .sidearm-mm-main-header {
      background-color: $color-white;
      color: $color-black;
      transform: translate(-50%, -50%);
      width: 100%;

      &__quick-nav {
        ul {
          @include flex-item(1 1 auto);
        }

        li {
          @include flex-item(1 1 auto);

          &::after {
            @include flex-item(1 1 0px);

            opacity: 1;
          }

          &.is-active {
            &::after {
              border-color: $color-black;
            }

            button::before {
              border: 1px dashed $color-black;
              transform: scale(1) translate(-50%, -50%);
            }
          }
        }

        button {
          &::before {
            border-color: $stroke-on-light;
          }
        }
      }

      &__menu-toggle {
        &::before,
        &::after {
          background-color: $color-black;
        }
      }

      &__tag {
        abbr {
          -webkit-text-stroke-color: $color-black;
          color: rgba($color-black, 0);
        }
      }
    }
  }
}
</style>
